import React from 'react';

export function LimitedList({
  items,
  maxItems,
  tag: Tag = 'span',
  itemKey = (_item, index) => index,
  renderItem = () => null,
}) {
  const slicedItems = items.slice(0, maxItems - 1);
  const additionalItemsCount = Math.max(0, items.length - (maxItems - 1));

  return (
    <>
      {slicedItems.map((item, i) => (
        <Tag key={itemKey(item, i)} className="item">
          {renderItem(item, i)}
        </Tag>
      ))}
      {additionalItemsCount > 0 && (
        <Tag className="additional-items">+ {additionalItemsCount} more</Tag>
      )}
    </>
  );
}

export default LimitedList;
